/*
シーンを返す
 */
var getScrollScene = function(controller,option,tween,Scene) {
    var _Scene = Scene ? Scene : new ScrollScene(option);
    if(tween){
        _Scene.setTween(tween);
    }
    var scene = _Scene.addTo(controller);
    return scene;
};

module.exports = getScrollScene;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/getScrollScene.js
 **/